import Login from "../Login/Login";
import { Route, Routes } from "react-router-dom";
import AdminLayout from "../Router/AdminLayout";
import Dashboard from "../pages/Dashboard/Dashboard";
import AuthorListing from "../pages/Author/AuthorListing";
import Category from "../pages/category/Category";
import BlogListing from "../pages/blogs/BlogListing";
import AddBlog from "../pages/blogs/AddBlog";
import EditBlog from "../pages/blogs/EditBlog";
import Contact from "../pages/Contact/Contact";
import SeoListing from "../pages/Seo/SeoListing";
import SeoCreate from "../pages/Seo/SeoCreate";
import SeoEdit from "../pages/Seo/SeoEdit";
import Tags from "../pages/tags/Tags";
import CasestudyListing from "../pages/Casestudy/CasestudyListing";
import AddCasestudy from "../pages/Casestudy/AddCasestudy";
import EditCasestudy from "../pages/Casestudy/EditCasestudy";
import Press from "../pages/press/Press";
import AddPress from "../pages/press/AddPress";
import EditPress from "../pages/press/EditPress";
import DynamicPage from "../pages/dynamicPage/DynamicPage";
import AddDynamicPage from "../pages/dynamicPage/AddDynamicPage";
import EditDynamicPage from "../pages/dynamicPage/EditDynamicPage";
import FaqListing from "../pages/Faq/FaqListing";
import AddFaq from "../pages/Faq/AddFaq";
import EditFaq from "../pages/Faq/EditFaq";
import SchemaManagement from "../pages/SchemaManagement/SchemaManagement";
import SitemapEditor from "../pages/sitemap/SitemapEditor";
import LlmsEditor from "../pages/Llms/LlmsEditor";
import RobotsManagement from "../pages/Robots/RobotsManagement";
import EmailManagement from "../pages/EmailManagement/EmailManagement";
import AddEmailManagement from "../pages/EmailManagement/AddEmailManagement";
import EditEmailManagement from "../pages/EmailManagement/EditEmailManagement";
import RoutePermissionGuard from "../hoc/RoutePermissionGuard";
import Users from "../pages/Rbac/Users";
import Roles from "../pages/Rbac/Roles";
import Permissions from "../pages/Rbac/Permissions";

export default function Router() {
  return (
    <>
      <Routes>
        <Route path={"login"} element={<Login />} />
        <Route path="/" element={<AdminLayout />}>
          <Route element={<RoutePermissionGuard />}>
            <Route index element={<Dashboard />} />

            {/* Blog Module */}
            <Route path="author" element={<AuthorListing />} />
            <Route path="category" element={<Category />} />
            <Route path="tags" element={<Tags />} />
            <Route path="blog" element={<BlogListing />} />
            <Route path="add-blog" element={<AddBlog />} />
            <Route path="edit-blog/:blog_id" element={<EditBlog />} />

            {/* Contact Module */}
            <Route path="contact" element={<Contact/>} />

            {/* Seo Module */}
            <Route path="seo" element={<SeoListing/>} />
            <Route path="add-seo" element={<SeoCreate/>} />
            <Route path="edit-seo/:seo_id" element={<SeoEdit/>} />
            <Route path="global-seo" element={<SchemaManagement/>} />
            <Route path="sitemap" element={<SitemapEditor/>} />
            <Route path="llms" element={<LlmsEditor/>} />
            <Route path="robots" element={<RobotsManagement/>} />
            <Route path="email-management" element={<EmailManagement/>} />
            <Route path="add-email-management" element={<AddEmailManagement/>} />
            <Route path="edit-email-management/:dynamicemail_id" element={<EditEmailManagement/>} />

            {/* Offer Module */}
            <Route path="case-study" element={<CasestudyListing />} />
            <Route path="add-casestudy" element={<AddCasestudy />} />
            <Route path="edit-casestudy/:casestudy_id" element={<EditCasestudy />} />

            {/* Press Module */}
            <Route path="press" element={<Press />} />
            <Route path="add-press" element={<AddPress />} />
            <Route path="edit-press/:press_id" element={<EditPress />} />

            {/* Dynamic Page Module */}
            <Route path="dynamic-page" element={<DynamicPage />} />
            <Route path="add-dynamic-page" element={<AddDynamicPage />} />
            <Route path="edit-dynamic-page/:dynamicpage_id" element={<EditDynamicPage />} />

            {/* FAQ Module */}
            <Route path="faq" element={<FaqListing />} />
            <Route path="add-faq" element={<AddFaq />} />
            <Route path="edit-faq/:faq_id" element={<EditFaq />} />

            {/* User Management Module */}
            <Route path="users" element={<Users />} />
            <Route path="roles" element={<Roles />} />
            <Route path="permissions" element={<Permissions />} />
          </Route>
 
        </Route>
      </Routes>
    </>
  )
}
